export default {
  hasItem: (breadcrumb, category) => {
    let found = Object.keys(breadcrumb).filter((key) => {
      return breadcrumb[key].name === category;
    });

    return found.length;
  }
}
